module.exports = __webpack_public_path__ + "static/media/puzzle-4-bg.12668c98.svg";